import { useRootSelector } from '../../../../store/hooks';
import { selectSiteFeaturedArticlesList } from '../../../../store/features/siteArticles';
import ProductsBlogGrid, {
  ProductCardSizes,
} from '../../../hub/shared/productFilter/products/ProductsBlogGrid';
import ArticleBlogCard from '../../../hub/shared/productFilter/cards/ArticleBlogCard';
import { selectPageConfig } from '../../../../store/features/pageConfig';

export default function FeaturedArticlesList() {
  const featuredArticles = useRootSelector(selectSiteFeaturedArticlesList);
  const { sitePath } = useRootSelector(selectPageConfig);

  if (featuredArticles.length === 0) {
    return null;
  }

  const largeArticles = featuredArticles.slice(0, 1);
  const mediumArticles = featuredArticles.slice(1, 3);
  const smallArticles = featuredArticles.slice(3, 7);

  return (
    <div className="container">
      <ProductsBlogGrid
        largeProductItems={largeArticles}
        mediumProductItems={mediumArticles}
        smallProductItems={smallArticles}
        renderProduct={(renderProps) => {
          const { productSize, productIndex } = renderProps;
          const displayImageMobileOnly =
            productSize === ProductCardSizes.medium && productIndex !== 0;

          return (
            <ArticleBlogCard
              data={renderProps.product}
              productSize={
                productSize === ProductCardSizes.medium
                  ? ProductCardSizes.small
                  : productSize
              }
              pathPrefix={`${sitePath}/article/`}
              displayImageMobileOnly={displayImageMobileOnly}
            />
          );
        }}
      />
    </div>
  );
}
